export const POSITION = {
  PREV: 'prev',
  NEXT: 'next',
  CURRENT: 'current',
  HIDDEN: 'hidden',
};

export const ALIGNMENT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const SPREAD = {
  NARROW: 'narrow',
  MEDIUM: 'medium',
  WIDE: 'wide',
};

export const TWITTER_LINK = 'https://twitter.com/CryptuniqueC';
export const INSTAGRAM_LINK = 'https://www.instagram.com/cryptunique/';
export const OPENSEA_LINK = 'https://opensea.io/collection/crypto-penis-punk-club';
export const DISCORD_LINK = 'https://discord.gg/7cmUEE99gK';
export const REDDIT_LINK = 'https://www.reddit.com/user/Cryptunique';
